module.exports = __webpack_public_path__ + "assets/img/qt-no.7c909dd2.png";